// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + (chunkId === 3677 ? "dynamic-import-insitepanel" : chunkId) + "." + {"3677":"9528dcb050bc686a77d5","8674":"1118c8fdcfd2e5f225fd"}[chunkId] + ".js";
};